import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import {
	C4ListResponse,
	CarrierTable,
	DropdownItem,
	ProjectDTO,
	RestService,
	TASK_STATUS_UUID,
	TASK_TABLE,
	TaskDTO,
	TaskTable,
	TaskUpdateRequest,
} from 'cargo-chief-commons';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { SelectionModel } from '@angular/cdk/collections';
import { UtilService } from '@service/util/util.service';
import { UrlService } from '@service/url/url.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';

@Component({
	selector: 'app-tasks-icon',
	templateUrl: './tasks-icon.component.html',
	styleUrls: ['./tasks-icon.component.scss'],
})
export class TasksIconComponent implements OnInit, OnChanges {
	@Input() taskList: Array<TaskTable> = null;
	@Input() carrier: CarrierTable = null;
	@Input() project: ProjectDTO = null;
	@Input() isLoadingTasks: boolean = false;

	@Output() taskAddedEvent: EventEmitter<TaskTable> = new EventEmitter();
	@Output() tasksUpdatedEvent: EventEmitter<Array<TaskTable>> = new EventEmitter();

	dataSource: MatTableDataSource<TaskTable> = new MatTableDataSource([]);
	displayedColumns = ['select', 'title', 'status'];
	selection = new SelectionModel<TaskTable>(true, []);
	taskStatusList: DropdownItem[];
	request: TaskUpdateRequest = {
		taskIds: [],
		statusId: null,
		dueDate: null,
		projectId: null,
		carrierId: null,
		assigneeId: null,
	};

	constructor(
		public utilService: UtilService,
		private urlService: UrlService,
		private restService: RestService
	) {
		this.taskStatusList = Object.keys(TASK_STATUS_UUID).map((key) => {
			return {
				label: TASK_STATUS_UUID[key],
				value: key,
			};
		});
	}

	ngOnInit() {}

	ngOnChanges(): void {
		if (this.utilService.isNullOrUndefined(this.taskList)) {
			return;
		}
		this.dataSource = new MatTableDataSource<TaskTable>(this.taskList);
	}

	isAllSelected() {
		const numSelected = this.selection.selected.length;
		const numRows = this.dataSource.data.length;
		return numSelected == numRows;
	}

	masterToggle() {
		this.isAllSelected()
			? this.selection.clear()
			: this.dataSource?.data?.forEach((row) => this.selection.select(row));
	}

	taskAdded(task: TaskDTO) {
		const addedTask: TaskTable = TASK_TABLE([task])[0];
		this.taskAddedEvent.emit(addedTask);
	}

	updateStatus(statusId: string) {
		this.request.statusId = statusId;
		this.request.taskIds = this.selection.selected.map((task) => task.id);
		const url = this.urlService.bulkUpdateTasks();
		this.restService.PUT(url, this.request).subscribe(
			(response: C4ListResponse<TaskDTO>) => {
				const updatedTasks = TASK_TABLE(response['data']);
				this.tasksUpdatedEvent.emit(updatedTasks);
				this.utilService.showSnackbar(
					`${this.selection.selected.length} tasks updated successfully.`,
					SNACKBAR.SUCCESS,
					SNACKBAR.ACTION
				);
				this.selection.clear();
			},
			(error) => {
				this.utilService.showSnackbar('Unable to update tasks.', SNACKBAR.ERROR, SNACKBAR.ACTION);
			}
		);
	}
}
